import { Link, useLocation } from "react-router-dom";
import { Home, Search, ShoppingBag, ClipboardList, User, LayoutDashboard, Package, PoundSterling } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useBasket } from "@/context/BasketContext";

const customerItems = [
  { to: "/", label: "Home", icon: Home, testid: "mobile-nav-home" },
  { to: "/browse", label: "Browse", icon: Search, testid: "mobile-nav-browse" },
  { to: "/basket", label: "Basket", icon: ShoppingBag, testid: "mobile-nav-basket" },
  { to: "/orders", label: "Orders", icon: ClipboardList, testid: "mobile-nav-orders" },
  { to: "/account", label: "Account", icon: User, testid: "mobile-nav-account" },
];

const sellerItems = [
  { to: "/seller", label: "Dashboard", icon: LayoutDashboard, testid: "mobile-nav-dashboard" },
  { to: "/seller/products", label: "Products", icon: Package, testid: "mobile-nav-products" },
  { to: "/seller/orders", label: "Orders", icon: ClipboardList, testid: "mobile-nav-seller-orders" },
  { to: "/seller/sales", label: "Sales", icon: PoundSterling, testid: "mobile-nav-sales" },
  { to: "/account", label: "Account", icon: User, testid: "mobile-nav-account" },
];

export function MobileNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { count } = useBasket();
  const items = user && user.role === "seller" ? sellerItems : customerItems;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-[#E5DEC9] z-50 flex justify-around items-center h-16 md:hidden">
      {items.map((it) => {
        const active = it.to === "/" ? pathname === "/" : pathname.startsWith(it.to);
        const Icon = it.icon;
        return (
          <Link key={it.to} to={it.to} data-testid={it.testid}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full relative ${active ? "text-[#1A3C2A]" : "text-[#9A9282]"}`}>
            <div className="relative">
              <Icon size={21} className={active ? "fill-[#1A3C2A]/10" : ""} />
              {it.to === "/basket" && count > 0 && (
                <span className="absolute -top-1.5 -right-2 bg-[#E07A5F] text-white text-[9px] font-bold min-w-[15px] h-[15px] rounded-full flex items-center justify-center px-0.5">{count}</span>
              )}
            </div>
            <span className="text-[10px] font-semibold">{it.label}</span>
            {active && <span className="absolute top-0 w-8 h-0.5 bg-[#E07A5F] rounded-full" />}
          </Link>
        );
      })}
    </nav>
  );
}
